// Only the status tones the shared Panel's StateBadge uses, unchanged.
export type Tone = 'ok' | 'idle' | 'warn' | 'alert' | 'muted'

export interface StateLabel {
  label: string
  tone: Tone
  detail: string | null
}

export const TONE_CLASS: Record<Tone, string> = {
  ok: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  idle: 'border-gray-300 bg-gray-50 text-gray-600',
  warn: 'border-amber-200 bg-amber-50 text-amber-700',
  alert: 'border-red-200 bg-red-50 text-red-700',
  muted: 'border-gray-300 bg-white text-gray-500',
}

export const TONE_DOT: Record<Tone, string> = {
  ok: 'bg-emerald-500',
  idle: 'bg-gray-400',
  warn: 'bg-amber-500',
  alert: 'bg-red-500',
  muted: 'bg-gray-300',
}
